import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ contentWidth, breakpoints }: Theme) => ({
  root: {
    width: '100%',
    maxWidth: contentWidth,
    margin: '0 auto',
    padding: '0 1.25rem',
    [breakpoints.up('xl')]: {
      padding: 0,
    },
  },
}));
